module.exports = __webpack_public_path__ + "img/card-silver-member.b8d9127f.png";